import moment from "moment"
import React from "react"
import Icon from "./Icon"
import states from "./states"

export const isNumber = (s, nozero) => {
    let n = parseInt(s, 10)
    if (isNaN(n) || n < 0) return false
    if (n === 0 && nozero === true) return false
    if (n.toString() !== s.toString()) return false
    return true
}

export const formatCardBrand = brand => {
    switch (brand) {
        case "visa":
            return "VISA"
        case "mastercard":
            return "MasterCard"
        case "amex":
            return "American Express"
        case "diners":
            return "Diners Club"
        case "discover":
            return "Discover"
        case "jcb":
            return "JCB"
        default:
            return "Unknown"
    }
}

export const formatState = state => {
    return states[state] || ""
}

export const formatPDD = value => {
    return <span style={value > 1400 ? { color: "red" } : {}}>{value}</span>
}

export const formatNumber = (amount, decimalCount = 0, decimal = ".", thousands = ",") => {
    try {
        decimalCount = Math.abs(decimalCount)
        decimalCount = isNaN(decimalCount) ? 2 : decimalCount

        const negativeSign = amount < 0 ? "-" : ""

        let i = parseInt((amount = Math.abs(Number(amount) || 0).toFixed(decimalCount))).toString()
        let j = i.length > 3 ? i.length % 3 : 0

        return (
            negativeSign +
            (j ? i.substr(0, j) + thousands : "") +
            i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) +
            (decimalCount
                ? decimal +
                  Math.abs(amount - i)
                      .toFixed(decimalCount)
                      .slice(2)
                : "")
        )
    } catch (e) {
        console.log(e)
    }
}

export const formatPhone = value => {
    let phone = value ? value.replace(/[^0-9]+/g, "") : ""
    if (phone.length === 11 && phone.substr(0, 1) === "1") {
        phone = phone.substr(1)
    }
    if (phone.length === 10) {
        phone = "(" + phone.substr(0, 3) + ") " + phone.substr(3, 3) + "-" + phone.substr(6)
    }
    return phone
}

export const formatMoney = (value, prec) => {
    let val = value ? value : 0
    if (prec === undefined) prec = 2
    if (prec === 2 && Math.abs(val) > 0 && Math.abs(val) < 0.01) prec = 4
    const sign = val < 0 ? "−" : ""
    return sign + "$" + formatNumber(Math.abs(val), prec)
}

export const formatTime = time => {
    const h = Math.floor(time / (60 * 60))
    const m = Math.floor((time % (60 * 60)) / 60)
    const s = time % 60
    const result = h + ":" + String(m).padStart(2, "0") + ":" + String(s).padStart(2, "0")
    return result
}

export const formatTimeMS = _time => {
    let time = _time
    if (isNaN(time) || time < 0) time = 0
    const m = Math.floor(time / 60)
    const s = time % 60
    const result = String(m) + ":" + String(s).padStart(2, "0")
    return result
}

export const formatDateTime = time => {
    return (
        <>
            <span>{moment(time).format("L")} </span>{" "}
            <span className="text-nowrap">
                <Icon color="#3683BC" icon={["far", "clock"]} /> <strong>{moment(time).format("LT")}</strong>
            </span>
        </>
    )
}

export const DateTime = React.memo(({ time, showTime = true, isDraft }) => {
    return (
        <div style={{ ...(isDraft ? { color: "#aaa" } : {}) }} className="d-flex flex-column align-items-center">
            <span>{moment(time).format("L")} </span>{" "}
            {showTime && (
                <span className="text-nowrap">
                    <Icon color="#3683BC" icon={["far", "clock"]} /> <strong>{moment(time).format("LT")}</strong>
                </span>
            )}
        </div>
    )
})

export const formatDateTimeSimple = time => {
    return moment(time).format("L LT")
}
export const formatDateSimple = time => moment(time).format("L")

export const formatDate = date => {
    return <>{moment(date).format("L")}</>
}

export const formatAddress = item => {
    let address = item.get("address").trim()
    if (address) address += ", "
    if (item.get("city")) address += item.get("city").trim() + " "
    address += [item.get("state"), item.get("postalcode")]
        .map(v => v.trim())
        .filter(v => !!v)
        .join(", ")
    return address
}

export const fixTime = (apitime, timeOffset) => {
    return timeOffset !== 0 ? moment(apitime.substring(0, 19)) : moment(apitime)
}

export const noNaN = value => {
    return value ? value : 0
}

export const trimStrings = data => {
    return data.map(item => (typeof item === "string" ? item.trim() : item))
}

export const convertTypes = (data, types) => {
    return data.map((v, k) => {
        switch (types[k]) {
            case "int":
                v = parseInt(v, 10)
                return isNaN(v) ? 0 : v
            case "decimal":
                v = parseFloat(v)
                return isNaN(v) ? 0 : v
            default:
                return v
        }
    })
}

export const parseCookie = () => {
    return document.cookie.split(";").reduce((res, c) => {
        const [key, val] = c.trim().split("=").map(decodeURIComponent)
        try {
            return Object.assign(res, { [key]: JSON.parse(val) })
        } catch (e) {
            return Object.assign(res, { [key]: val })
        }
    }, {})
}

const defaultAbc = "ABCDEFGHLMNPRSTWXYZacefghmnpqrstwxyz2345789"

export const getRandomInt = max => {
    return Math.floor(Math.random() * Math.floor(max))
}

export const generate = (length, inabc) => {
    let abc = inabc ? inabc : defaultAbc
    let out = ""
    for (let i = 0; i < length; i++) {
        let num = getRandomInt(abc.length)
        out += abc[num]
    }
    return out
}

export const formatDuration = v => {
    const h = Math.floor(v / 3600)
    const m = Math.floor((v % 3600) / 60)
    const s = v % 60
    const out = []
    if (h > 0) {
        out.push(h + " hour" + (h > 1 ? "s" : ""))
    }
    if (m > 0) {
        out.push(m + " minute" + (m > 1 ? "s" : ""))
    }
    if (s > 0) {
        out.push(s + " second" + (s > 1 ? "s" : ""))
    }
    return out.join(" ")
}

export const getTimeIntervals = () => {
    let timeoutIntervals = []
    for (let i of [5, 10, 15, 30, 1 * 60, 5 * 60, 10 * 60]) {
        timeoutIntervals.push({ value: i, label: formatDuration(i) })
    }
    for (let i = 15; i <= 120; i += 15) {
        timeoutIntervals.push({ value: i * 60, label: formatDuration(i * 60) })
    }
    return timeoutIntervals
}

export const hslToHex = (h, s, l) => {
    h /= 360
    s /= 100
    l /= 100
    let r, g, b
    if (s === 0) {
        r = g = b = l // achromatic
    } else {
        const hue2rgb = (p, q, t) => {
            if (t < 0) t += 1
            if (t > 1) t -= 1
            if (t < 1 / 6) return p + (q - p) * 6 * t
            if (t < 1 / 2) return q
            if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6
            return p
        }
        const q = l < 0.5 ? l * (1 + s) : l + s - l * s
        const p = 2 * l - q
        r = hue2rgb(p, q, h + 1 / 3)
        g = hue2rgb(p, q, h)
        b = hue2rgb(p, q, h - 1 / 3)
    }
    const toHex = x => {
        const hex = Math.round(x * 255).toString(16)
        return hex.length === 1 ? "0" + hex : hex
    }
    return `#${toHex(r)}${toHex(g)}${toHex(b)}`
}

export const shuffle = a => {
    for (let i = a.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1))
        ;[a[i], a[j]] = [a[j], a[i]]
    }
    return a
}

export const plural = (value, single, plural) => {
    return value + " " + (value === 1 ? single : plural)
}

export const shortenEmail = (email, length) => {
    const p = email.split("@")
    const cut = email.length - length + 1
    if (cut <= 0) return email
    if (p[0].length > cut) {
        return p[0].substring(0, p[0].length - cut) + "…@" + p[1]
    }
    return email.substring(0, length - 1) + "…"
}

export const loadScript = (src, scriptId, isDefer, isAsync) => {
    var script = document.createElement("script")
    script.defer = isDefer
    script.async = isAsync
    script.src = src
    if (scriptId !== undefined) {
        script.id = scriptId
    }
    document.getElementsByTagName("head")[0].appendChild(script)
}

export const themeApplyer = (styleID, style) => {
    const head = document.head || document.getElementsByTagName("head")[0]
    if (!document.getElementById(styleID)) {
        const styleEl = document.createElement("style")
        styleEl.setAttribute("id", styleID)
        styleEl.textContent = style
        head.appendChild(styleEl)
    }
}

export const artifactApplyer = (artifactID, artifact) => {
    const head = document.head || document.getElementsByTagName("head")[0]
    if (!document.getElementById(artifactID)) {
        head.appendChild(artifact)
    }
}

export const remover = prefix => document.querySelectorAll(`[id^="${prefix}"]`).forEach(el => el.remove())
